module.exports = __webpack_public_path__ + "static/media/chevron-left.51e10261.svg";